<template>
  <Layout>
    <b-row tag="article" v-if="!post">
      <div class="col m-5 text-center">
        <b-spinner label="Spinning"></b-spinner>
      </div>
    </b-row>
    <b-row class="m-5 mb-3">
      <b-col>
        <h1 class="mt-5 mb-3">{{post.title.rendered}}</h1>
        <hr />
        <p class="date" style="color:black">{{formatDate(post.date)}}</p>
      </b-col>
    </b-row>
    <b-row class="m-5 mb-3">
       <b-col cols> 
         <b-img :src="thumbnail(post)" fluid style="width:80%; height:auto; "/>
       </b-col>
 
    </b-row>
    <b-row tag="article" class="m-5 text-left block-content">
      <b-col cols v-html="post.content.rendered"></b-col>
    </b-row>
  </Layout>
</template>

<script>
import axios from "axios";
import moment from "moment";
import config from "../../public/data/config.json";
export default {
  metaInfo: {
    title: "Noticia"
  },
  props: {
    id: null
  },
  methods: {
    formatDate(date) {
      return moment(date, "DD-MM-YYYY")
        .locale("es_ve")
        .format("MMMM Do YYYY");
    },
    thumbnail(post) {
      if (typeof post._embedded["wp:featuredmedia"] === "undefined") {
        return "https://via.placeholder.com/350x250";
      } else {
        return post._embedded["wp:featuredmedia"]["0"].source_url;
      }
    },
    async loadData() {
      this.loading;
      this.id = this.$route.params.id;
      try {
        const result = await axios.get(
          config.URL + "/posts/" + this.id + "?_embed"
        );
        this.post = result.data;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    }
  },
  data() {
    return {
      post: null,
      loading: true
    };
  },
  async mounted() {
    this.loadData();
  }
};
</script>
<style scoped>
.block-title {
  font-style: normal;
  font-weight: 800;
  color: black;
  font-size: 18px;
}
.date {
  font-size: 14px;
  color: #969696;
  font-weight: 600;
  text-align: left;
}
</style>
